import { render } from "./SegregationDetail.vue?vue&type=template&id=d7b7ccf8&ts=true"
import script from "./SegregationDetail.vue?vue&type=script&lang=ts"
export * from "./SegregationDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__